// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AMJg","placeholdersHeader":"styles_placeholdersHeader__1aalv","editorStyle":"styles_editorStyle__3EMoH","placeholdersBox":"styles_placeholdersBox__fkTE7"};